import { Wrench } from 'lucide-react';

interface V3ActionsProps {
    row: any;
    onRepair: () => void;
}

export default function V3Actions({ row, onRepair }: V3ActionsProps) {
    return (
        <span className="Table-options">
            <Wrench onClick={onRepair} className="size-4 cursor-pointer" />
        </span>
    );
}
